import { yupMixed, yupObject, yupString } from '@/validation/yup';
import { ErhlExitStrategyOptions, type ErhlExitStrategyEnum } from '@/helpers/const';

/**
 * Validation schema for the ERHL exit strategy step.
 * Includes exit strategy selection and required details text.
 */
export const erhlExitStrategySchema = yupObject({
  exitStrategy: yupMixed<ErhlExitStrategyEnum>()
    .required()
    .oneOf(Object.keys(ErhlExitStrategyOptions) as ErhlExitStrategyEnum[])
    .label('Repayment strategy'),
  exitStrategyDetails: yupString()
    .required('Please provide more details on the repayment strategy')
    .label('Repayment strategy details'),
});

/** D2C variant: same fields, with customer-facing wording on the details error. */
export const erhlCustomerExitStrategySchema = erhlExitStrategySchema.shape({
  exitStrategyDetails: yupString()
    .required('Please provide more details on your repayment strategy')
    .label('Repayment strategy details'),
});
